import { Path } from '@/main/router/routerPath';

import { BankovniUcet } from './bankovniUcet';
import { DokladSk } from './dokladsk';
import { SazbaDph } from './dphsazba';
import { DruhDokladu } from './druhDokladu';
import { KategoriePrac } from './kategoriePrac';
import { Mena } from './mena';
import { MenaKurz } from './menakurz';
import { NakladoveStredisko } from './nakladoveStredisko';
import { NakladoveStrediskoTyp } from './nakladoveStrediskoTyp';
import { Pokladna } from './pokladna';
import { ReklamaText } from './reklamaText';
import { Stanoviste } from './stanoviste';
import { Stat } from './stat';
import { Texty } from './texty';
import { Tymprac } from './tymprac';
import { ZakazkaDruh } from './zakazkaDruh';
import { EmailText } from './emailText';
import { SmsText } from './smsText';
import { DokladCiselnaRada } from './dokladCiselnaRada';

export const router = new Path('Firemni').addChildren([
	BankovniUcet.router,
	DokladSk.router,
	SazbaDph.router,
	DruhDokladu.router,
	EmailText.router,
	KategoriePrac.router,
	Mena.router,
	MenaKurz.router,
	NakladoveStredisko.router,
	NakladoveStrediskoTyp.router,
	Pokladna.router,
	ReklamaText.router,
	Stanoviste.router,
	Stat.router,
	Texty.router,
	Tymprac.router,
	ZakazkaDruh.router,
	SmsText.router,
	DokladCiselnaRada.router,
]);
